import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["teamSelect", "newTeam", "category", "categoryColumn", "ageGroupFields", "email", "submit"]
  static values = { existingCategories: Array, exhausted: Boolean }

  connect() {
    this.teamChanged()
    this.emailChanged()
  }

  teamChanged() {
    const creating = this.teamSelectTarget.value === "new"
    this.newTeamTarget.classList.toggle("d-none", !creating)
    this.newTeamTarget.disabled = !creating
    this.categoryChanged()
  }

  categoryChanged() {
    if (!this.hasCategoryTarget) return

    const exists = this.existingCategoriesValue.map(String).includes(this.categoryTarget.value)
    const showAgeGroup = this.teamSelectTarget.value === "new" && !exists
    this.ageGroupFieldsTargets.forEach((element) => {
      element.classList.toggle("d-none", !showAgeGroup)
      this.setEnabled(element, showAgeGroup)
    })
    if (this.hasCategoryColumnTarget) {
      this.categoryColumnTarget.classList.toggle("col-sm-6", !exists)
    }
  }

  setEnabled(container, enabled) {
    container.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = !enabled
    })
  }

  emailChanged() {
    const ready = !this.exhaustedValue && this.emailTarget.value.trim().length > 0
    this.submitTarget.disabled = !ready
    this.submitTarget.classList.toggle("btn-flat-primary", ready)
  }
}
